export default {
  REGISTER_SUCCESS: "Registration completed successfully.",
  LOGIN_SUCCESS: "You have logged in successfully.",
  ERROR: "Something went wrong !",
  ERROR_FORM: "There was an error submitting the form !",
  ADD_SUCCESS: "Added successfully !",
  SAVED_SUCCESS: "Saved successfully !",
  Load_SUCCESS: "Data Loaded !",
  Not_AVAILABLE: "Data Not Available",
  UPDATE_SUCCESS: "Updated successfully !",
  SELECT_FILE: "Please Select a file",
  UPLOAD_SUCCESS: "Upload successfully !",
  OTP_VERIFIED: "Otp verified !",
  OTP_SENT: "OTP has been successfully sent to your mobile number.",
  NOT_VERIFIED: "User not verified !",
  ADD_ROLE: {
    INVALID_ROLE_NAME: "Please enter role name !",
  },
  PLEASE_ENTER: "Please Enter",
};
